"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _UrlParts = _interopRequireDefault(require("./parts/UrlParts"));

var DOMAIN_REGEX = new RegExp("^" + _UrlParts.default.domain + "$", 'i');
var _default = DOMAIN_REGEX;
exports.default = _default;
module.exports = exports.default;